import styles from './CardActivationPage.css';
import BodyText from '../shared/Typography/BodyText';
import Title from '../shared/Typography/Title';
import useTranslation from '../../localization/i18n.context';
import Button from '../shared/Button/Button';
import NumberInput from '../shared/NumberInput/NumberInput';
import { CardType, getCardAssetURL } from '../../clients/card.backgrounds';

const CARD_DIGITS_LENGTH = 4;

export default function CardNumberStep({
  value,
  onInput,
  organizationCode,
  error = null,
}) {
  const { t, getOrganization } = useTranslation();

  const isButtonEnabled =
    value && value.length === CARD_DIGITS_LENGTH && /\d{4}/.test(value);

  return (
    <main className={styles.main}>
      <div className={styles.content} data-testid="four-digits">
        <div className={styles.head}>
          <Title
            text={t('Enter the last 4-digits from your card number')}
            className={styles.title}
          />
          <BodyText
            data-testid="four-digits-info"
            text={t(
              'Your card number is on the back of your {card name} card',
              { '{card name}': getOrganization(organizationCode) },
            )}
          />
        </div>
        <div className={styles['form-controller']}>
          <NumberInput
            length={CARD_DIGITS_LENGTH}
            value={value}
            onChange={v => {
              onInput('cardNumber', v);
            }}
            hasError={!!error}
            helperText={error}
          />
        </div>

        <img
          src={getCardAssetURL(organizationCode, CardType.CARD_LAST_DIGITS)}
          className={styles.image}
        />
      </div>
      <div className="fixed-cta">
        <Button fullWidth disabled={!isButtonEnabled}>
          {t('Continue')}
        </Button>
      </div>
    </main>
  );
}
